import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GetSettingsResponse } from '../models/GetSettingsResponse';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  getSettings(app: string, username: string, configId: number, authPerCustomer: boolean, crmId:string) {
    app = app || "";
    var configIdText = configId || "";
    username = username || "";
    return this.http.get<GetSettingsResponse>(`${environment.login_service_url}/api/auth/settings?username=${username}&app=${app}&configId=${configIdText}&authPerCustomer=${authPerCustomer}&crmId=${crmId}`);
  }

  refreshToken(force = false) {
    return this.http.get(`${environment.login_service_url}/api/auth/refresh?forceRefresh=${force}`, { withCredentials: true });
  }
  checkSession() {
    return this.http.get(`${environment.login_service_url}/api/auth/session`, { withCredentials: true });
  }
  getServerSettings(serverId:string) {
    return this.http.get(`${environment.login_service_url}/api/auth/serverSettings/${serverId}`, { withCredentials: true });
  }
  constructor(private http:HttpClient) { }
}
